import template from 'product-full-details.j2';

import { generate } from '../../../core/js/utils/componentUtils';
import { dDom } from '../../../core/js/utils/renderUtils';
import { onStateChange } from '../utils/productComponentUtils';

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-main-product .dom-product-full-details',
        onStateChange: onStateChange,
        watch: 'quickshop.product.productMeta.url',
        renderType: dDom,
        template: template,
        name: 'quickshopFullDetailsComponent',
        forFamilyProduct: false
    };

    return generate(config, store, overrides);
}
